import { isEqual as compare } from "lodash";
import { Policy } from "../../../../hooks/useRoleMutations";

export type ActionTypes = "INIT" | "ADD" | "REMOVE" | "CLEAN";

export interface PolicyState {
  isDirty: boolean;
  policies: Array<Policy>;
}

export const INITIAL_POLICY_STATE: PolicyState = {
  isDirty: false,
  policies: [],
};

export type PoliciesAction = {
  type: ActionTypes;
  payload?: any;
};

let initialPolicies: Array<Policy>;

export function PoliciesReducer(state: PolicyState, action: PoliciesAction) {
  switch (action.type) {
    case "INIT": {
      initialPolicies = action.payload;
      return { ...state, policies: action.payload, isDirty: false };
    }

    case "ADD": {
      const isEqual = compare(initialPolicies, [
        ...state.policies,
        action.payload,
      ]);

      return {
        ...state,
        policies: [...state.policies, action.payload],
        isDirty: !isEqual,
      };
    }

    case "REMOVE": {
      const newPolicies = state.policies.filter(
        (policy) => policy.id !== action.payload
      );

      const isEqual = compare(initialPolicies, newPolicies);

      return { ...state, policies: newPolicies, isDirty: !isEqual };
    }

    case "CLEAN":
      return { ...state, isDirty: false };

    default:
      return { ...state };
  }
}
